import { AlertTriangle, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DangerZoneProps {
  entityLabel: string;
  description?: string;
  onDelete: () => void;
  disabled?: boolean;
}

export function DangerZone({ entityLabel, description, onDelete, disabled = false }: DangerZoneProps) {
  return (
    <div className="mt-6 rounded-lg border border-destructive/50 bg-destructive/5 p-4">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-destructive mt-0.5 shrink-0" />
        <div className="flex-1">
          <h4 className="font-semibold text-destructive mb-1">Danger zone</h4>
          <p className="text-sm text-muted-foreground mb-3">
            {description ?? `Permanently delete this ${entityLabel}. This action cannot be undone.`}
          </p>
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={onDelete}
            disabled={disabled}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Delete {entityLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
